import React from 'react';
import Breadcrumbs from '@/widgets/breadcrumbs';
import EditSolicitationProvider from '../../components/apis/edit-solicitation-provider';
import ReOpenPeriods from './reopen-periods';
import { breadcrumbsPath } from '../../utils/solicitation-helpers';

const ReOpenPeriodWrapper = () => {
  return (
    <div
      className="grid-col margin-bottom-8"
      data-testId="re-open-periods-wrapper"
    >
      <Breadcrumbs current="Edit Solicitation" path={breadcrumbsPath} />
      <EditSolicitationProvider>
        <ReOpenPeriods />
      </EditSolicitationProvider>
    </div>
  );
};

export default ReOpenPeriodWrapper;
